
import gif from "../../images/glowgif01.gif";


import e from "../../images/e.png";
import ml from "../../images/ml.jpg";
import cyber from "../../images/cyber.jpg";



import train from "../../images/training01.png"
import training from "../../images/training.jpg";
import bgImage2 from "../../images/glow.png";
import './Training.css';
import EastIcon from '@mui/icons-material/East';

import { useMediaQuery } from 'react-responsive'
import { useNavigate } from 'react-router-dom';

import 'swiper/css';
import 'swiper/css/pagination';
import React, { useEffect, useState, useRef } from 'react';

// import FileUploader from './FileUploader';


export const Training = () => {
  const isMobileScreen = useMediaQuery({ query: '(max-width: 900px)' })
  const navigate = useNavigate();
  const handleJoinNowClick = () => {
    const url = "https://forms.office.com/Pages/ResponsePage.aspx?id=tyjdRuz3r0e4Spk5XXjNRu6D1IpZpNpEhgSE6_5_gVZUMzBRUEJITVhLWFRXV0dNNUVPTFZMMEpFSyQlQCN0PWcu"; // Replace with your desired URL
    window.open(url, "_blank");
    // Add your logic here
  };
  const scrollToTop = () => {
    window.scrollTo(0, 0);
}
  const handleExploreCourse = (courseId: string) => {
    navigate(`/training/course/${courseId}`);
    scrollToTop();
  };
  const [width, setWidth] = useState(window.innerWidth);
  const heroRef = useRef<HTMLDivElement | null>(null);
  const backgroundRef = useRef<HTMLDivElement | null>(null);



  useEffect(() => {
    const animateValue = (obj: HTMLElement, start: number, end: number, duration: number) => {
      let startTimestamp: number | null = null;
      const step = (timestamp: number) => {
        if (!startTimestamp) startTimestamp = timestamp;
        const progress = Math.min((timestamp - startTimestamp) / duration, 1);
        obj.innerHTML = Math.floor(progress * (end - start) + start).toString();
        if (progress < 1) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    };
  
    // Select all elements with a specific class
    const elements = document.querySelectorAll<HTMLElement>(".animate-value");
  
    if (elements.length === 0) {
      console.error("No elements with class 'animate-value' found in the DOM.");
      return;
    }
  
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const target = entry.target as HTMLElement;
            const endValue = parseInt(target.getAttribute("data-end") || "100", 10); // Use `data-end` for dynamic values
            animateValue(target, 0, endValue, 2000); // Start animation
            observer.unobserve(target); // Stop observing this element after animation starts
          }
        });
      },
      { threshold: 0.5 } // Trigger when 50% of the element is visible
    );
  
    // Observe each element
    elements.forEach((element) => observer.observe(element));
  
    return () => {
      observer.disconnect(); // Cleanup observer on component unmount
    };
  }, []);
  
  useEffect(() => {
    if (heroRef.current && backgroundRef.current) {
      heroRef.current.style.background = 'none';
      backgroundRef.current.style.backgroundImage = `url(${bgImage2})`;
    }
    const handleScroll = () => {
      if (backgroundRef.current) {
        const maxScroll = 630;
        const maxScaleTransform = 1.6;
        const maxScaleTop = 1.68;
        let scale = window.scrollY / 900 + 1;
        let scale1 = Math.max(1.6, scale);
        let scaleTop = window.scrollY / 910 + 1;
        let scaleside = window.scrollY / 910 + 1;
          console.log(window.scrollY );
      
        // if (window.scrollY > maxScroll) {
        //   backgroundRef.current.style.transform = `scale(1.6, 1.6)`;
        //   // backgroundRef.current.style.left = '-5%';
        //   scaleTop = 1.68;
          
        //   // backgroundRef.current.style.top = ``;

        // }
        if (window.scrollY > maxScroll) { 
          scale1= maxScaleTransform;
   
          scaleside = maxScaleTop ;
          scaleTop = maxScaleTop;
   

        }
        // if (window.scrollY > 750) { 
        //   scale1= maxScaleTransform;
   
        //   // scaleside = -(scaleside - 1) ;
        //   backgroundRef.current.style.left = `${(26.47 * scaleside) + 36.47}%`;
   

        // }
      

        backgroundRef.current.style.transform = `scale(${scale1 }, ${scale1 })`;
        // backgroundRef.current.style.transformOrigin = 'bottom right';
        backgroundRef.current.style.bottom = `-${(scaleTop - 1) *100}%`;
        // backgroundRef.current.style.left = `${(-26.47 * scaleside) + 30.47}%`;
      }
    };
    const handleScrollMobile = () => {
      if (backgroundRef.current) {
        const maxScroll = 630;
        const maxScaleTransform = 1.6;
        const maxScaleTop = 1.68;
        let scale = window.scrollY / 900 + 1;
        let scale1 = Math.max(1.6, scale);
        let scaleTop = window.scrollY / 910 + 1;
        let scaleside = window.scrollY / 910 + 1;
          console.log(window.scrollY );
      
        // if (window.scrollY > maxScroll) {
        //   backgroundRef.current.style.transform = `scale(1.6, 1.6)`;
        //   // backgroundRef.current.style.left = '-5%';
        //   scaleTop = 1.68;
          
        //   // backgroundRef.current.style.top = ``;

        // }
        if (window.scrollY > maxScroll) { 
          scale1= maxScaleTransform;
   
          scaleside = maxScaleTop ;
          scaleTop = 1.8;
   

        }
        // if (window.scrollY > 750) { 
        //   scale1= maxScaleTransform;
   
        //   // scaleside = -(scaleside - 1) ;
        //   backgroundRef.current.style.left = `${(26.47 * scaleside) + 36.47}%`;
   

        // }
      

        // backgroundRef.current.style.transform = `scale(${scale1 }, ${scale1 })`;
        // backgroundRef.current.style.txransformOrigin = 'bottom right';
        // backgroundRef.current.style.top = `${(-22.05 * scaleTop) + 47}%`;
        backgroundRef.current.style.bottom = `-${(scaleTop - 1) *100}%`;
        // backgroundRef.current.style.left = `${(-30.47 * scaleside) + 26.47}%`;
      }
    };
    const updateScrollHandler = () => {
      const isMobile = window.innerWidth <= 900; // Adjust breakpoint as needed
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('scroll', handleScrollMobile);
  
      if (isMobile) {
        window.addEventListener('scroll', handleScrollMobile);
      } else {
        window.addEventListener('scroll', handleScroll);
      }
    };
  
    // Set the initial scroll handler
    updateScrollHandler();
     // Update the scroll handler on resize
  window.addEventListener('resize', updateScrollHandler);
    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('scroll', handleScrollMobile);
      window.removeEventListener('resize', updateScrollHandler);
    };
}, []);

  
  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div id="wrapper2_d">
    <section id='hero2_d' ref={heroRef} className="hero2_d"
    // style={{ backgroundImage: `url(${bgImage2})`, backgroundSize: 'auto', background: 'cover' }}
    >
         <div   className='glow_2'></div>

<div ref={backgroundRef} className="background">
<div   ref={backgroundRef}className='glow'></div>
</div>
<div className="background2"></div>
      {/* <div ref={backgroundRef} className="background">
      Staffing
      </div> */}
      <div className='hero__flex'  >
     
      <div className='hero__left'  >
      <div className='img_box'>
      <img src={training}  className='intro_img first'  />
      <img src={train}  className='intro_img'  />
      {/* <img src={staff}  className='intro_img'  />   */}
      <div className='intro_img'>
      <div style={{display:'flex',flexDirection:'row',justifyContent:'center',}}>
        <div className="num animate-value"  data-end="4">0</div><a style={{fontSize:'30px',paddingLeft:'0px'}}>+</a>
        </div>
        <div className="text">Present Courses</div>
      </div>
 <div className='intro_img'>
 <div style={{display:'flex',flexDirection:'row',justifyContent:'center'}}>
        <div className="num animate-value"  data-end="100">0</div><a style={{fontSize:'30px',paddingLeft:'0px'}}>+</a>
        </div>
        <div className="text">Professionals Trained</div>
      </div>
            </div>
         </div>
        
         <div className='hero__right'  >
         <div>
        <div className='rightbox_paragraph_up'>
     Training
            </div>
            <a>-Intell<img src={e} className='elogo' />Sphere</a>
            </div>
           
      <div className='rightbox_paragraph'>
      <a>Building a Foundation for Lasting Success Through
Talent Development.</a><br></br>
IT staffing is more than just placement; it's about empowering individuals and
organizations to thrive. Which is why, alongside our talent acquisition, we're
deeply invested in cultivating a workforce that's not just ready for today's
challenges, but getting equipped for tomorrow's opportunities. </div>
           
           
         </div>
      
      </div>
    </section>

    <div className='section3_d'>
    {/* <a>WHAT WE DO</a>
            <h1>Services at Tekcog</h1> */}
           <div className='sevices_in_t'>
            <div className='sevices_box_t animate'>
       
            <a>Readying Talent for Real-World Impact</a>
           
            <p>We believe in going beyond
technical skills. Our job-readiness programs instill crucial professional behaviors
– think effective communication, time management, and a strong work ethic –
ensuring our IT staffing candidates integrate seamlessly and contribute
meaningfully from day one.</p>
        
            </div>
            
            <div className='sevices_box_t animate'>
            <img
            // src={devops}
            className='animeImg'
            
            />
            <a>Cultivating Expertise Across Industries</a>
           
            <p>Recognizing the diverse
landscape of IT, our industry-focused training modules are precisely tailored.
Whether it&#39;s the nuances of healthcare IT, the specifics of financial technology, or
the demands of software development, we deliver targeted learning that aligns
with current industry standards and meet your unique needs.</p>
        
            </div>
       
     
            {/* <img
            src={Tlogo}
            className='imageSide'
            
            /> */}
           </div>
           <div className='sevices_in2_t '>
         
 

         <div className='sevices_box2_t animate'>
         <img
         // src={s}
         className='animeImg'
         
         />
         <a>Ensuring a Smooth Start and Long-Term Engagement</a>
        
         <p>We understand
that a positive onboarding experience is key. Our structured onboarding and
integration support accelerates new hire productivity, boosts retention, and
fosters a confident and engaged workforce right from the outset.</p>
     
         </div>
         <div className='sevices_box2_t animate'>
         <img
         // src={dMedia}
         className='animeImg'
         
         />
         <a>Empowering Growth Through Continuous Learning</a>
        
         <p>In this rapidly
evolving tech world, staying ahead is paramount, our upskilling and reskilling
initiatives offer scalable training programs in cutting-edge technologies,
programming languages, and digital tools, ensuring your talent remains relevant
and competitive.</p>
     
         </div>
         <div className='sevices_box2_t animate'>
         <img
         // src={dMedia}
         className='animeImg'
         
         />
         <a>Building Trust Through Compliance and Expertise</a>
        
         <p>We provide expert-
led training meticulously aligned with critical regulatory frameworks and industry
certifications. We equip your workforce with the knowledge and credentials that
build confidence and ensure compliance.</p>
     
         </div>
         {/* <img
         src={Tlogo}
         className='imageSide'
         
         /> */}
        </div>
          
    </div>
    <div className='section4_P'>
    <div className='center animate'>
            <img src={gif} className='logoIS' />
             </div>
   <h2>Courses We Offer Now. Get Enrolled Soon!!</h2>
<div className='sec_contain_t'>
            <div className='sec_box_t'  >
            <img
            src={ml}
            className='animeImg' />
            <div className='sec_box_content'>
            <h1>Machine Learning and AI</h1>
            <p>Course Duration: 3 months</p>
            <a>Build a Portfolio of  Machine Learning Projects with Python, SVM, Regression, <br></br>Unsupervised Machine Learning & More!</a>
           <div style={{display:'flex',flexDirection:(isMobileScreen ? 'column':'row'),justifyContent:'space-between',
           width:'100%',alignItems:(isMobileScreen ? 'flex-start':'flex-end')}}>
            {/* <ul>
            <li>Python fundamentls & tools </li>
            <li>Machine Learning Algorithms</li>
            <li>Bulid AI projects</li>
            <li>Real-world AI use cases</li>
            </ul> */}
          
            <div className='join_button' 
            onClick={() => handleExploreCourse('machine-learning-ai')}
            >
         Explore Now
         <EastIcon className='arrow' ></EastIcon>
         </div>
            </div>
            </div>
      
            </div>
            <div className='sec_box_t'  >
            <img
            src={cyber} 
            className='animeImg' />
            <div className='sec_box_content'>
            <h1>AI Cybersecurity Guardian </h1>
            <p>Course Duration: 3 months</p>
            <a>Master the Art of Cyber Security: Learn Essential Skills for Online Safety and Protect <br></br>Your Digital World Unsupervised Machine Learning & More!</a>
            <div style={{display:'flex',flexDirection:(isMobileScreen ? 'column':'row'),justifyContent:'space-between',
           width:'100%',alignItems:(isMobileScreen ? 'flex-start':'flex-end')}}>            
           {/* <ul>
            <li>Security Governance, Network Security</li>
            <li>Cyber Attacks, Web Application Security, Malware</li>
            <li>Prepare for Cyber Security interviews </li>
            <li> CompTIA Security+ and CEH</li>
            </ul> */}
            <div className='join_button'
            onClick={() => handleExploreCourse('ai-cybersecurity-guardian')}
            >
         Explore Now
         <EastIcon className='arrow' ></EastIcon>
         </div>
            </div>
            </div>
      
            </div>
            <div className='sec_box_t'  >
            <img
            src={cyber} 
            className='animeImg' />
            <div className='sec_box_content'>
            <h1>VLSI Design and Verification </h1>
            <p>Course Duration: 3 months</p>
            <a>Master the Art of VLSI Design and Verification: Learn Essential Skills for Online Safety and Protect <br></br>Your Digital World Unsupervised Machine Learning & More!</a>
            <div style={{display:'flex',flexDirection:(isMobileScreen ? 'column':'row'),justifyContent:'space-between',
           width:'100%',alignItems:(isMobileScreen ? 'flex-start':'flex-end')}}>            
           {/* <ul>
            <li>Security Governance, Network Security</li>
            <li>Cyber Attacks, Web Application Security, Malware</li>
            <li>Prepare for Cyber Security interviews </li>
            <li> CompTIA Security+ and CEH</li>
            </ul> */}
            <div className='join_button'
            onClick={() => handleExploreCourse('vlsi-design-verification')}
            >
         Explore Now
         <EastIcon className='arrow' ></EastIcon>
         </div>
            </div>
            </div>
      
            </div>
          
           </div>
          
           </div>

  
          
    </div>
    
    
  )
}






